import { useEffect, useState } from 'react';
import { claimOncePerSession } from '../../components/Fireworks';
import { useWorkScheduleProfiles } from './useWorkScheduleProfiles';

/**
 * A small fireworks burst the first time a member with a work-schedule profile lands on
 * the digest in a browser session — "when Kora logs in" (Dan, 2026-09-08). Profiles arrive
 * from IndexedDB/sync a beat after mount, so the claim waits for the profile rather than
 * deciding on the first render; nobody without a profile ever sees it.
 */
export function useArrivalFireworks(userId: string): { show: boolean; dismiss: () => void } {
  const { profiles } = useWorkScheduleProfiles();
  const eligible = profiles.has(userId);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!eligible) return;
    if (claimOncePerSession(`awwyeah:arrival-fireworks:${userId}`)) setShow(true);
  }, [eligible, userId]);

  return { show, dismiss: () => setShow(false) };
}
